import React, { useEffect, useState, useCallback } from "react"
import moment from "moment"
import * as Yup from "yup"
import { parsePhoneNumber } from "libphonenumber-js"
import { Form, Field, FastField, withFormik } from "formik"
import {
  CheckBox,
  TextField,
  MobileNumberField,
  CountryField,
  StateField,
  CityField,
  BarangayField,
  SelectField
} from "../../../common/Fields"
import PickupList from "./PickupList"
import "./ShippingForm.css"
import Lalamove from "../Lalamove"
import { API, API_PUBLIC } from "../../../api"

let submitValue = false
const setSubmitValue = value => {
  submitValue = value
}

function BaseShippingForm(props) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldError,
    setValues,
    setSubmitting,
    isSubmitting,
    customerInfo,
    customerAddress,
    deliveryData,
    orderData,
    pickupAddressList,
    backHandler,
    setDeliveryData,
    countryList,
    canSelectAllCountry,
    isCustomShipping,
    setCustomerAddress,
    setCustomerData,
    activeCouriers,
    customerData,
    deliveryMethodName,
    isNewOrder,
    products,
    customProducts,
    newOrderAccountUuid
  } = props

  const [selectedCourier, setSelectedCourier] = useState(deliveryData.method)
  useEffect(
    () => {
      setFieldValue("method", deliveryMethodName)
    },
    [deliveryMethodName, setFieldValue]
  )
  useEffect(
    () => {
      if (!values.preferPickup) {
        if (values.toMe) {
          // setCustomerData({
          //   firstName: values.firstName,
          //   lastName: values.lastName,
          //   email: values.email,
          //   mobile: values.mobile
          // })
          setCustomerAddress({
            addressOne: values.addressOne || "",
            addressTwo: values.addressTwo || "",
            barangay: values.barangay || "",
            city: values.city || "",
            country: values.country || {},
            state: values.state || {},
            zipcode: values.zipcode || "",
            deliveryDate: values.deliveryDate,
            deliveryTime: values.deliveryTime,
            deliveryLocation: values.deliveryLocation
          })
          setDeliveryData({
            method: values.method || "",
            preferPickup: values.preferPickup,
            pickUpAddress: values.pickUpAddress,
            toMe: values.toMe,
            deliveryDate: null,
            deliveryTime: null,
            country: values.country || {}
          })
        } else {
          setDeliveryData({
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobile,
            addressOne: values.addressOne || "",
            addressTwo: values.addressTwo || "",
            barangay: values.barangay || "",
            city: values.city || "",
            country: values.country || {},
            state: values.state || {},
            zipcode: values.zipcode || "",
            method: values.method || "",
            preferPickup: values.preferPickup,
            pickUpAddress: values.pickUpAddress,
            toMe: values.toMe,
            deliveryDate: values.deliveryDate,
            deliveryTime: values.deliveryTime
          })
        }
        // if (values.method.value && values.method.value.name === "Lalamove") {
        //   setDeliveryData({
        //     firstName: values.firstName,
        //     lastName: values.lastName,
        //     email: values.email,
        //     mobile: values.mobile,
        //     addressOne: values.addressOne || "",
        //     addressTwo: values.addressTwo || "",
        //     barangay: values.barangay.value || "",
        //     city: values.city.value || values.city || "",
        //     country: values.country || {},
        //     state: values.state || {},
        //     zipcode: values.zipcode || "",
        //     method: values.method || "",
        //     courier_id: (values.method && values.method.value.id) || null,
        //     preferPickup: values.preferPickup,
        //     pickUpAddress: values.pickUpAddress,
        //     toMe: values.toMe,
        //     deliveryDate: values.deliveryDate,
        //     deliveryTime: values.deliveryTime,
        //     addressString: values.addressString,
        //     latLng: values.latLng
        //   })
        // }
      } else {
        setDeliveryData({
          method: values.method || "",
          preferPickup: values.preferPickup,
          pickUpAddress: values.pickUpAddress,
          toMe: values.toMe
        })
      }
    },
    [
      values.country.value,
      values.state.value,
      values.addressOne,
      values.addressTwo,
      values.zipcode,
      setCustomerAddress,
      setCustomerData,
      setDeliveryData,
      values.barangay,
      values.city,
      values.country,
      values.email,
      values.firstName,
      values.lastName,
      values.method,
      values.mobile,
      values.pickUpAddress,
      values.preferPickup,
      values.state,
      values.toMe,
      values.deliveryDate,
      values.deliveryTime,
      values.deliveryLocation,
      values.latLng,
      values.addressString,
      deliveryData.courier_id
    ]
  )

  function handleCountryChange(val) {
    if (val.value !== values.country.value) {
      setFieldValue("state", {})
      setFieldValue("city", "")
      setFieldValue("barangay", "")
    }
    setFieldValue("country", val)
  }

  function handleStateChange(val) {
    if (val.value !== values.state.value) {
      setFieldValue("city", "")
      setFieldValue("barangay", "")
    }
    setFieldValue("state", val)
  }

  function handleCityChange(val) {
    if (
      !val.hasOwnProperty("value") ||
      val.hasOwnProperty("value") !== values.city.hasOwnProperty("value") ||
      (val.hasOwnProperty("value") && val.value !== values.city.value)
    ) {
      setFieldValue("barangay", "")
    }
    setFieldValue("city", val)
  }

  function handleCourierChange(val) {
    setSelectedCourier(val.value.name)
    setFieldValue("method", val.value.name)
    setDeliveryData({
      ...deliveryData,
      preferPickup: false,
      courier_id: val.value.id,
      method: val.value.name
    })
  }

  function handlePreferPickup() {
    const selectedPickUp = pickupAddressList.find(
      address => address.id === deliveryData.pickUpAddress
    )
    const pickUpCountry =
      (selectedPickUp &&
        selectedPickUp.address &&
        selectedPickUp.address.country) ||
      null
    setSelectedCourier("")
    const val = !values.preferPickup
    setFieldValue("preferPickup", val)
    setDeliveryData({
      ...deliveryData,
      preferPickup: val,
      courier_id: null,
      country: { label: pickUpCountry, value: pickUpCountry } || {}
    })
    if (pickUpCountry) {
      setCustomerAddress({
        ...customerAddress,
        country: { label: pickUpCountry, value: pickUpCountry }
      })
    }
    if (isNewOrder) {
      setFieldValue("method", "Pickup")
    }
  }

  async function toMeChange() {
    // setFieldValue("toMe", values.toMe === true ? false : true)
    await Promise.resolve()
    if (!values.toMe) {
      setValues({
        ...values,
        toMe: !values.toMe,
        firstName: customerInfo.firstName || "",
        lastName: customerInfo.lastName || "",
        email: customerInfo.email || "",
        mobile: customerInfo.mobile || { countryCode: "", mobileNumber: "" },
        addressOne: customerAddress.addressOne || "",
        addressTwo: customerAddress.addressTwo || "",
        barangay: customerAddress.barangay || "",
        city: customerAddress.city || "",
        zipcode: customerAddress.zipcode || "",
        country: customerAddress.country || "",
        state: customerAddress.state || "",
        deliveryDate: (customerAddress && customerAddress.deliveryDate) || "",
        deliveryTime: (customerAddress && customerAddress.deliveryTime) || "",
        deliveryLocation:
          (customerAddress && customerAddress.deliveryLocation) ||
          (deliveryData &&
            deliveryData.misc &&
            deliveryData.misc.deliveryLocation) ||
          null
      })
    } else {
      setValues({
        ...values,
        toMe: !values.toMe,
        firstName: (deliveryData && deliveryData.firstName) || "",
        lastName: (deliveryData && deliveryData.lastName) || "",
        email: (customerInfo && customerInfo.email) || "",
        mobile: (deliveryData && deliveryData.mobile) || {
          countryCode: "",
          mobileNumber: ""
        },
        addressOne: (deliveryData && deliveryData.addressOne) || "",
        addressTwo: (deliveryData && deliveryData.addressTwo) || "",
        barangay: (deliveryData && deliveryData.barangay) || "",
        city: (deliveryData && deliveryData.city) || "",
        zipcode: (deliveryData && deliveryData.zipcode) || "",
        country:
          (deliveryData && deliveryData.country) ||
          customerAddress.country ||
          "",
        state: (deliveryData && deliveryData.state) || "",
        deliveryDate: (deliveryData && deliveryData.deliveryDate) || "",
        deliveryTime: (deliveryData && deliveryData.deliveryTime) || "",
        deliveryLocation:
          (deliveryData && deliveryData.deliveryLocation) || null
      })
    }
  }

  const handleLalamoveChange = useCallback(
    async () => {
      if (!isSubmitting && !submitValue) {
        if (
          deliveryData &&
          deliveryData.courier_id &&
          deliveryData.method === "lalamove"
        ) {
          try {
            setSubmitValue(false)
            setSubmitting(true)
            let courier = (deliveryData && deliveryData.courier) || null
            if (
              !courier ||
              (values.deliveryLocation &&
                values.deliveryDate &&
                values.deliveryTime &&
                ((courier &&
                  courier.stops[1].location.lat !==
                    String(values.deliveryLocation.lat)) ||
                  (courier &&
                    courier.stops[1].location.lng !==
                      String(values.deliveryLocation.lng)) ||
                  (courier &&
                    courier.scheduleAt !==
                      moment(`${values.deliveryDate} ${values.deliveryTime}`)
                        .utc()
                        .format()) ||
                  (courier && deliveryData.shippingFee === 0)))
            ) {
              const orderWeight = (isNewOrder
                ? [...products, customProducts]
                : orderData.products
              ).reduce((total, product) => {
                total +=
                  product.shipment_weight *
                  (product.weight_unit === "kg" ? 1000 : 1)
                return total
              }, 0)
              courier = {
                scheduleAt:
                  (values.deliveryDate &&
                    values.deliveryTime &&
                    moment(`${values.deliveryDate} ${values.deliveryTime}`)
                      .utc()
                      .format()) ||
                  (courier && courier.scheduleAt) ||
                  "",
                serviceType:
                  (courier && courier.serviceType) ||
                  (orderWeight <= 20000 && "MOTORCYCLE") ||
                  "MPV",
                specialRequests:
                  (courier && courier.specialRequests) ||
                  (orderWeight <= 20000 && ["LALABAG"]) ||
                  [],
                requesterContact: (courier && courier.requesterContact) || {
                  name: `${orderData.seller &&
                    orderData.seller.first_name} ${orderData.seller &&
                    orderData.seller.last_name}`,
                  phone: `0${orderData.seller &&
                    orderData.seller.mobile.mobileNumber}`
                },
                stops: [
                  (courier && courier.stops[0]) || {
                    location: {
                      lat:
                        orderData.seller && orderData.seller.origin_address.lat,
                      lng:
                        orderData.seller && orderData.seller.origin_address.lng
                    },
                    addresses: {
                      en_PH: {
                        displayString:
                          (orderData.seller &&
                            orderData.seller.origin_address.address_line_1) ||
                          "",
                        country: "PH"
                      }
                    }
                  },
                  {
                    location: {
                      lat: values.deliveryLocation
                        ? String(values.deliveryLocation.lat)
                        : "14.6075852",
                      lng: values.deliveryLocation
                        ? String(values.deliveryLocation.lng)
                        : "121.0788904"
                    },
                    addresses: {
                      en_PH: {
                        displayString: values.addressOne || "",
                        country: "PH"
                      }
                    }
                  }
                ],
                deliveries: [
                  {
                    toStop: 1,
                    toContact: {
                      name:
                        values.firstName &&
                        values.firstName !== "" &&
                        values.lastName &&
                        values.lastName !== ""
                          ? `${values.firstName} ${values.lastName}`
                          : `${customerInfo.firstName} ${
                              customerInfo.lastName
                            }`,
                      phone: `0${
                        values.mobile.mobileNumber &&
                        values.mobile.mobileNumber !== ""
                          ? values.mobile.mobileNumber
                          : customerInfo.mobile.mobileNumber
                      }`
                    },
                    remarks: orderData.customer_remark || ""
                  }
                ]
              }

              // setFetching(true)
              API_PUBLIC.defaults.headers.common["account-uuid"] = isNewOrder
                ? newOrderAccountUuid
                : customerData.account
              const getRate = await API_PUBLIC.post(
                "checkout/courier/lalamove/get_rate",
                courier
              )
              const {
                data: { data }
              } = getRate
              courier["quotedTotalFee"] = {
                amount: String(Number(data.totalFee)),
                currency: "PHP"
              }
              const handlingFee =
                orderData.rates.data.shipping.courier.find(
                  c => c.name === selectedCourier
                ).amount || 0
              let lalamoveData = (deliveryData && deliveryData.misc) || null
              lalamoveData = {
                data: "lalamove",
                origin: (deliveryData.misc && deliveryData.misc.origin) || {
                  address_line_one:
                    orderData.seller.origin_address.address_line_1,
                  address_line_two:
                    orderData.seller.origin_address.address_line_2,
                  city: orderData.seller.origin_address.city,
                  country: orderData.seller.origin_address.country,
                  firstname: orderData.seller.first_name,
                  lastname: orderData.seller.last_name,
                  province: orderData.seller.origin_address.province,
                  zipcode: orderData.seller.origin_address.zipcode
                },
                originMobile: (deliveryData.misc &&
                  deliveryData.misc.originMobile) || {
                  countryCode: orderData.seller.mobile.countryCode,
                  mobileNumber: orderData.seller.mobile.mobileNumber
                },
                originLocation: (deliveryData.misc &&
                  deliveryData.misc.originLocation) || {
                  lat: parseFloat(orderData.seller.origin_address.lat),
                  lng: parseFloat(orderData.seller.origin_address.lng),
                  place_id: orderData.seller.origin_address.place_id
                },
                delivery: !(deliveryData.misc && deliveryData.misc.delivery)
                  ? {
                      address_line_one: values.addressOne || "",
                      address_line_two: values.addressTwo || "",
                      city:
                        (values.city.hasOwnProperty("value") &&
                          values.city.value) ||
                        values.city ||
                        "",
                      country: values.country || "",
                      firstname: values.firstName,
                      lastname: values.lastName,
                      province: values.state || "",
                      zipcode: values.zipcode
                    }
                  : deliveryData.misc.delivery,
                deliveryMobile: !(
                  deliveryData.misc && deliveryData.misc.deliveryMobile
                )
                  ? {
                      countryCode:
                        values.mobile.countryCode ||
                        customerInfo.mobile.countryCode,
                      mobileNumber:
                        values.mobile.mobileNumber ||
                        customerInfo.mobile.mobileNumber
                    }
                  : deliveryData.misc.deliveryMobile,
                deliveryLocation: values.deliveryLocation,
                withAddress: "true"
              }
              setDeliveryData({
                ...deliveryData,
                shippingFee: Number(handlingFee) + Number(data.totalFee),
                courier: courier,
                misc: lalamoveData,
                toMe: values.toMe
              })
            }
          } catch (error) {
            console.log(error)
            if (
              error.response &&
              error.response.data &&
              error.response.data.data &&
              error.response.data.data.message === "ERR_INVALID_SCHEDULE_TIME"
            ) {
              setFieldError("deliveryTime", "Delivery time is invalid.")
            } else if (
              error.response &&
              error.response.data &&
              error.response.data.data &&
              error.response.data.data.message === "ERR_OUT_OF_SERVICE_AREA"
            ) {
              setFieldError("deliveryLocation", "Delivery location is invalid.")
            }
          } finally {
            if (values.toMe) {
              setCustomerAddress({
                addressOne: values.addressOne || "",
                addressTwo: values.addressTwo || "",
                barangay: values.barangay || "",
                city: values.city || "",
                country: values.country || {},
                state: values.state || {},
                zipcode: values.zipcode || "",
                deliveryDate: values.deliveryDate,
                deliveryTime: values.deliveryTime,
                deliveryLocation: values.deliveryLocation
              })
              setDeliveryData({
                toMe: values.toMe
              })
            } else {
              setDeliveryData({
                deliveryDate: values.deliveryDate,
                deliveryTime: values.deliveryTime,
                deliveryLocation: values.deliveryLocation,
                addressOne: values.addressOne || "",
                addressTwo: values.addressTwo || "",
                city: values.city || "",
                country: values.country || {},
                state: values.state || {},
                zipcode: values.zipcode || "",
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                mobile: values.mobile,
                toMe: values.toMe
              })
            }
            setSubmitValue(true)
            setSubmitting(false)
          }
        }
      }
    },
    [
      values,
      deliveryData,
      orderData.rates.data.shipping.courier,
      selectedCourier,
      setDeliveryData,
      setCustomerAddress,
      customerInfo,
      orderData.customer_remark,
      orderData.seller,
      orderData.products,
      customerData.account,
      setFieldError,
      setSubmitting,
      isSubmitting,
      isNewOrder,
      products,
      newOrderAccountUuid,
      customProducts
    ]
  )

  useEffect(
    () => {
      if (!isSubmitting && submitValue) {
        setSubmitValue(false)
      } else handleLalamoveChange()
    },
    [handleLalamoveChange, isSubmitting]
  )

  const onFormKeyDown = e => {
    if (e && e.keyCode === 13) {
      e.preventDefault()
    } else {
      return e
    }
  }

  return (
    <Form onKeyDown={onFormKeyDown} className="ShippingForm">
      <span>
        <label>Delivery Method</label>
        {((values.preferPickup || activeCouriers.length < 1) && (
          <div className={"TextField disabled"}>
            <FastField
              type="text"
              name="method"
              value={deliveryMethodName}
              disabled={true}
            />
          </div>
        )) || (
          <FastField
            onChange={handleCourierChange}
            component={SelectField}
            options={activeCouriers.filter(
              item => item.value.name !== selectedCourier
            )}
            isSearchable={false}
            noOptionsMessage={() => null}
            value={
              (values.method &&
                !values.method.hasOwnProperty("value") && {
                  label: values.method,
                  value: values.method
                }) || { label: "", value: "" }
            }
            name="method"
            // disabled={props.isNewOrder}
          />
        )}
      </span>
      {pickupAddressList &&
        pickupAddressList.length > 0 &&
        !deliveryData.courier_id && (
          <Field
            component={CheckBox}
            name="preferPickup"
            onChange={handlePreferPickup}
            checked={values.preferPickup}
            placeholder="I prefer to pick up the items"
          />
        )}
      {(values.preferPickup &&
        pickupAddressList.length > 0 && (
          <PickupList
            pickupAddressList={pickupAddressList}
            selectedValue={values.pickUpAddress}
          />
        )) || (
        <>
          {selectedCourier &&
            selectedCourier.toLocaleLowerCase() === "lalamove" && (
              <Lalamove {...props} />
            )}
          <h3>Delivery Address</h3>
          <FastField
            component={CheckBox}
            name="toMe"
            onChange={toMeChange}
            checked={values.toMe}
            placeholder="Ship to me"
            disabled={isSubmitting}
          />
          {!values.toMe && (
            <div className="name">
              <span>
                <label>First Name</label>
                <FastField component={TextField} name="firstName" type="text" />
              </span>
              <span>
                <label>Last Name</label>
                <FastField component={TextField} name="lastName" type="text" />
              </span>
            </div>
          )}
          {/* {(!values.toMe ||
            (!orderData ||
              !orderData.customer_info ||
              !orderData.customer_info.mobile ||
              !orderData.customer_info.mobile.countryCode ||
              !orderData.customer_info.mobile.mobileNumber)) && (
            <>
              
            </>
          )}
          <span>
            <label>Email Address</label>
            <FastField component={TextField} name="email" type="text" />
          </span> */}
          <span>
            <label>Mobile Number</label>
            <MobileNumberField
              groupName="mobile"
              countryCodeName="countryCode"
              mobileNumberName="mobileNumber"
              errors={errors}
              touched={touched}
              values={values}
              disabled={values.toMe}
            />
          </span>
          <span>
            <label>Address Line 1</label>
            <FastField
              component={TextField}
              name="addressOne"
              type="text"
              placeholder="Street and number, P.O. box, c/o"
            />
          </span>
          <span>
            <label>Address Line 2 (Optional)</label>
            <FastField
              component={TextField}
              name="addressTwo"
              type="text"
              placeholder="Apartment, suite, unit building, floor, etc"
            />
          </span>
          <div className="country">
            <span>
              <label>Country</label>
              {(selectedCourier &&
                selectedCourier.toLocaleLowerCase() === "lalamove" && (
                  <FastField
                    component={SelectField}
                    name="country"
                    value={values.country}
                    options={[{ value: "philippines", label: "philippines" }]}
                    onChange={handleCountryChange}
                  />
                )) || (
                <FastField
                  component={CountryField}
                  name="country"
                  value={values.country}
                  availableCountries={!canSelectAllCountry ? countryList : null}
                  disabled={!canSelectAllCountry && isCustomShipping}
                  onChange={handleCountryChange}
                />
              )}
            </span>
            <span>
              <label>Province/State</label>
              <Field
                component={StateField}
                name="state"
                countryname={(values.country && values.country.value) || ""}
                value={values.state || ""}
                onChange={handleStateChange}
              />
            </span>
          </div>
          <div className="city">
            <span>
              <label>City</label>
              {(values.country.value &&
                values.country.value.toLowerCase() === "philippines" && (
                  <Field
                    name="city"
                    component={CityField}
                    value={values.city || ""}
                    type="text"
                    statename={(values.state && values.state.value) || ""}
                    onChange={handleCityChange}
                  />
                )) || (
                <FastField component={TextField} type="text" name="city" />
              )}
            </span>
            <span>
              <label>Zip Code</label>
              <FastField component={TextField} name="zipcode" type="text" />
            </span>
          </div>
          {values.country.value &&
            values.country.value.toLowerCase() === "philippines" && (
              <div className="city">
                <span>
                  <label>Barangay</label>
                  <Field
                    name="barangay"
                    component={BarangayField}
                    value={values.barangay}
                    type="text"
                    cityname={(values.city && values.city.value) || ""}
                  />
                </span>
                <span />
              </div>
            )}
        </>
      )}
      <button type="submit" className="black" disabled={isSubmitting}>
        Proceed to payment
      </button>
      <button type="button" className="gray" onClick={backHandler}>
        Back to customer information
      </button>
    </Form>
  )
}

const FormikShippingForm = withFormik({
  validateOnChange: true,
  // enableReinitialize: true,
  mapPropsToValues: props => {
    let formValues = {}
    if (props.deliveryData && !props.deliveryData.toMe) {
      formValues = {
        method: props.deliveryMethodName || "",
        // lalamove: false,
        preferPickup: props.deliveryData.preferPickup || false,
        pickUpAddress: props.deliveryData.pickUpAddress || "",
        toMe: props.deliveryData.toMe || false,
        firstName: props.deliveryData.firstName || "",
        lastName: props.deliveryData.lastName || "",
        email: props.deliveryData.email || "",
        mobile: props.deliveryData.mobile || "",
        addressOne: props.deliveryData.addressOne || "",
        addressTwo: props.deliveryData.addressTwo || "",
        barangay: props.deliveryData.barangay || "",
        city: props.deliveryData.city || "",
        zipcode: props.deliveryData.zipcode || "",
        country: props.deliveryData.country || "",
        state: props.deliveryData.state || "",
        deliveryDate:
          (props.deliveryData.deliveryDate &&
            props.deliveryData.deliveryDate !== "" &&
            props.deliveryData.deliveryDate) ||
          "",
        deliveryTime:
          (props.deliveryData.deliveryTime &&
            props.deliveryData.deliveryTime !== "" &&
            props.deliveryData.deliveryTime) ||
          "",
        deliveryLocation: null,
        addressString: "",
        latLng: ""
      }
    } else {
      formValues = {
        // lalamove: false,
        method: props.deliveryMethodName || "",
        preferPickup:
          (props.deliveryData && props.deliveryData.preferPickup) || false,
        pickUpAddress:
          (props.deliveryData && props.deliveryData.pickUpAddress) ||
          (props.pickupAddressList &&
            props.pickupAddressList.length > 0 &&
            props.pickupAddressList[0].id) ||
          "",
        toMe: (props.deliveryData && props.deliveryData.toMe) || true,
        firstName:
          (props.deliveryData &&
            props.deliveryData.misc &&
            props.deliveryData.misc.delivery &&
            props.deliveryData.misc.delivery.firstname) ||
          (props.customerInfo && props.customerInfo.firstName) ||
          "",
        lastName:
          (props.deliveryData &&
            props.deliveryData.misc &&
            props.deliveryData.misc.delivery &&
            props.deliveryData.misc.delivery.lastname) ||
          (props.customerInfo && props.customerInfo.lastName) ||
          "",
        email: (props.customerInfo && props.customerInfo.email) || "",
        mobile: (props.customerInfo && props.customerInfo.mobile) || {},
        addressOne:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.address_line_one || ""
            : (props.customerAddress && props.customerAddress.addressOne) || "",
        addressTwo:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.address_line_two || ""
            : (props.customerAddress && props.customerAddress.addressTwo) || "",
        barangay:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.barangay || ""
            : (props.customerAddress && props.customerAddress.barangay) || "",
        city:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.city || ""
            : (props.customerAddress && props.customerAddress.city) || "",
        zipcode:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.zipcode || ""
            : (props.customerAddress && props.customerAddress.zipcode) || "",
        country:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.country || ""
            : (props.customerAddress && props.customerAddress.country) || "",
        state:
          props.deliveryData &&
          props.deliveryData.misc &&
          props.deliveryData.misc.delivery
            ? props.deliveryData.misc.delivery.province || ""
            : (props.customerAddress && props.customerAddress.state) || "",
        deliveryDate:
          (props.customerAddress.deliveryDate &&
            props.customerAddress.deliveryDate !== "" &&
            props.customerAddress.deliveryDate) ||
          (props.deliveryData.courier &&
            props.deliveryData.courier.scheduleAt !== "" &&
            moment(props.deliveryData.courier.scheduleAt).format(
              "YYYY-MM-DD"
            )) ||
          (props.orderData.delivery &&
            props.orderData.delivery !== "" &&
            moment(props.orderData.delivery)
              .utc()
              .format("YYYY-MM-DD")) ||
          "",
        deliveryTime:
          (props.customerAddress.deliveryTime &&
            props.customerAddress.deliveryTime !== "" &&
            props.customerAddress.deliveryTime) ||
          (props.deliveryData.courier &&
            props.deliveryData.courier.scheduleAt !== "" &&
            moment(props.deliveryData.courier.scheduleAt).format("HH:mm:ss")) ||
          (props.orderData.delivery &&
            props.orderData.delivery !== "" &&
            moment(props.orderData.delivery)
              .utc()
              .format("HH:mm:ss")) ||
          "",
        deliveryLocation: null,
        addressString: "",
        latLng: ""
      }
    }
    if (props.deliveryData && !props.deliveryData.toMe) {
      if (props.deliveryData && props.deliveryData.deliveryLocation) {
        formValues["deliveryLocation"] = props.deliveryData.deliveryLocation
      }
    } else {
      if (props.customerAddress && props.customerAddress.deliveryLocation) {
        formValues["deliveryLocation"] = props.customerAddress.deliveryLocation
      } else if (props.deliveryData && props.deliveryData.misc) {
        formValues["deliveryLocation"] =
          props.deliveryData.misc.deliveryLocation
      }
    }
    return formValues
  },
  validationSchema: Yup.object().shape({
    method: Yup.string().required("Please enter a delivery method."),
    preferPickup: Yup.bool(),
    // lalamove: Yup.bool(),
    pickUpAddress: Yup.string(),
    toMe: Yup.bool(),
    firstName: Yup.string().required("Please enter a first name."),
    lastName: Yup.string().required("Please enter a last name."),
    email: Yup.string()
      .email("Please enter a valid email address.")
      .required("Please enter an email."),
    mobile: Yup.object().when("preferPickup", {
      is: true,
      then: Yup.object()
        .shape({
          countryCode: Yup.string()
            .matches(
              /^($)|(\+?\d{1,3}$|\d{1,4}$)/,
              "Please enter a valid country code."
            )
            .max(4, "Please enter a valid country code."),
          mobileNumber: Yup.string()
            .matches(
              /^($)|([0-9]{4,13}$)/,
              "Please enter a valid mobile number."
            )
            .max(13, "Please enter a valid mobile number.")
        })
        .test("test-phone", "Invalid mobile number", function(mobile) {
          if (`${mobile.countryCode}${mobile.mobileNumber}` !== "") {
            try {
              parsePhoneNumber(`${mobile.countryCode}${mobile.mobileNumber}`)
              return true
            } catch (e) {
              return false
            }
          }
          return true
        }),
      otherwise: Yup.object()
        .shape({
          countryCode: Yup.string()
            .matches(
              /^($)|(\+?\d{1,3}$|\d{1,4})/,
              "Please enter a valid country code."
            )
            .max(4, "Please enter a valid country code.")
            .required("Please enter a mobile number.")
            .typeError("Please enter a mobile number."),
          mobileNumber: Yup.string()
            .matches(
              /^($)|([0-9]{4,13})/,
              "Please enter a valid mobile number."
            )
            .max(13, "Please enter a valid mobile number.")
            .required("Please enter a mobile number.")
            .typeError("Please enter a mobile number.")
        })
        .test("test-phone", "Please enter a mobile number.", function(mobile) {
          if (`${mobile.countryCode}${mobile.mobileNumber}` !== "") {
            try {
              parsePhoneNumber(`${mobile.countryCode}${mobile.mobileNumber}`)
              return true
            } catch (e) {
              console.log(e)
              return false
            }
          }
          return true
        })
    }),
    addressOne: Yup.string().when("preferPickup", {
      is: true,
      then: Yup.string(),
      otherwise: Yup.string().required("Please enter an address.")
    }),
    addressTwo: Yup.string(),
    city: Yup.string().when("preferPickup", {
      is: true,
      then: Yup.string(),
      otherwise: Yup.string().required("Please enter a city.")
    }),
    barangay: Yup.string().when(
      ["preferPickup", "country"],
      (preferPickup, country) =>
        !preferPickup && country && country.value === "philippines"
          ? Yup.string().required("Please select a barangay.")
          : Yup.string()
    ),
    zipcode: Yup.string().when("preferPickup", {
      is: true,
      then: Yup.string(),
      otherwise: Yup.string()
        .max(5, "Please enter a valid zipcode.")
        .min(3, "Please enter a valid zipcode.")
        .required("Please enter a zip code.")
    }),
    country: Yup.object().when("preferPickup", {
      is: true,
      then: Yup.object(),
      otherwise: Yup.object().test(
        "test-country",
        "Please enter a country.",
        function(country) {
          if (
            country &&
            country.label &&
            country.label !== "" &&
            country.value &&
            country.value !== ""
          ) {
            return true
          }
          return false
        }
      )
    }),
    state: Yup.object().when("preferPickup", {
      is: true,
      then: Yup.object(),
      otherwise: Yup.object().test(
        "test-state",
        "Please enter a province/state.",
        function(state) {
          if (
            state &&
            state.label &&
            state.label !== "" &&
            state.value &&
            state.value !== ""
          ) {
            return true
          }
          return false
        }
      )
    }),
    deliveryDate: Yup.string(),
    deliveryTime: Yup.string()
  }),
  handleSubmit: async (values, { props, setFieldError }) => {
    const { isNewOrder, customProducts, products } = props
    if (!values.preferPickup) {
      try {
        const checkMobile = await API.get(
          `customers/${props.orderData.account}/${values.mobile.countryCode}${
            values.mobile.mobileNumber
          }`
        )
        const {
          data: { is_valid_mobile }
        } = checkMobile

        const { deliveryData, orderData, customerData, customerInfo } = props
        if (
          deliveryData &&
          deliveryData.courier_id &&
          deliveryData.method === "lalamove"
        ) {
          let courier = (deliveryData && deliveryData.courier) || null
          if (
            !courier ||
            (values.deliveryLocation &&
              values.deliveryDate &&
              values.deliveryTime)
          ) {
            const orderWeight = (isNewOrder
              ? [...products, ...customProducts]
              : orderData.products
            ).reduce((total, product) => {
              total +=
                product.shipment_weight *
                (product.weight_unit === "kg" ? 1000 : 1)
              return total
            }, 0)
            courier = {
              scheduleAt:
                (values.deliveryDate &&
                  values.deliveryTime &&
                  moment(`${values.deliveryDate} ${values.deliveryTime}`)
                    .utc()
                    .format()) ||
                (courier && courier.scheduleAt) ||
                "",
              serviceType:
                (courier && courier.serviceType) ||
                (orderWeight <= 20000 && "MOTORCYCLE") ||
                "MPV",
              specialRequests:
                (courier && courier.specialRequests) ||
                (orderWeight <= 20000 && ["LALABAG"]) ||
                [],
              requesterContact: (courier && courier.requesterContact) || {
                name: `${orderData.seller.first_name} ${
                  orderData.seller.last_name
                }`,
                phone: `0${orderData.seller.mobile.mobileNumber}`
              },
              stops: [
                (courier && courier.stops[0]) || {
                  location: {
                    lat: orderData.seller.origin_address.lat,
                    lng: orderData.seller.origin_address.lng
                  },
                  addresses: {
                    en_PH: {
                      displayString:
                        orderData.seller.origin_address.address_line_1 || "",
                      country: "PH"
                    }
                  }
                },
                {
                  location: {
                    lat: values.deliveryLocation
                      ? String(values.deliveryLocation.lat)
                      : "14.6075852",
                    lng: values.deliveryLocation
                      ? String(values.deliveryLocation.lng)
                      : "121.0788904"
                  },
                  addresses: {
                    en_PH: {
                      displayString: values.addressOne || "",
                      country: "PH"
                    }
                  }
                }
              ],
              deliveries: [
                {
                  toStop: 1,
                  toContact: {
                    name:
                      values.firstName &&
                      values.firstName !== "" &&
                      values.lastName &&
                      values.lastName !== ""
                        ? `${values.firstName} ${values.lastName}`
                        : `${customerInfo.firstName} ${customerInfo.lastName}`,
                    phone: `0${
                      values.mobile.mobileNumber &&
                      values.mobile.mobileNumber !== ""
                        ? values.mobile.mobileNumber
                        : customerInfo.mobile.mobileNumber
                    }`
                  },
                  remarks: orderData.customer_remark || ""
                }
              ]
            }

            // setFetching(true)
            API_PUBLIC.defaults.headers.common["account-uuid"] =
              customerData.account
            const getRate = await API_PUBLIC.post(
              "checkout/courier/lalamove/get_rate",
              courier
            )
            const {
              data: { data }
            } = getRate
            courier["quotedTotalFee"] = {
              amount: String(Number(data.totalFee)),
              currency: "PHP"
            }
            const handlingFee =
              orderData.rates.data.shipping.courier.find(
                c => c.name === deliveryData.method
              ).amount || 0
            let lalamoveData = (deliveryData && deliveryData.misc) || null
            lalamoveData = {
              data: "lalamove",
              origin: (deliveryData.misc && deliveryData.misc.origin) || {
                address_line_one:
                  orderData.seller.origin_address.address_line_1,
                address_line_two:
                  orderData.seller.origin_address.address_line_2,
                city: orderData.seller.origin_address.city,
                country: orderData.seller.origin_address.country,
                firstname: orderData.seller.first_name,
                lastname: orderData.seller.last_name,
                province: orderData.seller.origin_address.province,
                zipcode: orderData.seller.origin_address.zipcode
              },
              originMobile: (deliveryData.misc &&
                deliveryData.misc.originMobile) || {
                countryCode: orderData.seller.mobile.countryCode,
                mobileNumber: orderData.seller.mobile.mobileNumber
              },
              originLocation: (deliveryData.misc &&
                deliveryData.misc.originLocation) || {
                lat: parseFloat(orderData.seller.origin_address.lat),
                lng: parseFloat(orderData.seller.origin_address.lng),
                place_id: orderData.seller.origin_address.place_id
              },
              delivery: !(deliveryData.misc && deliveryData.misc.delivery)
                ? {
                    address_line_one: values.addressOne || "",
                    address_line_two: values.addressTwo || "",
                    city:
                      (values.city.hasOwnProperty("value") &&
                        values.city.value) ||
                      values.city ||
                      "",
                    country: values.country || "",
                    firstname: values.firstName,
                    lastname: values.lastName,
                    province: values.state || "",
                    zipcode: values.zipcode
                  }
                : deliveryData.misc.delivery,
              deliveryMobile: !(
                deliveryData.misc && deliveryData.misc.deliveryMobile
              )
                ? {
                    countryCode:
                      values.mobile.countryCode ||
                      customerInfo.mobile.countryCode,
                    mobileNumber:
                      values.mobile.mobileNumber ||
                      customerInfo.mobile.mobileNumber
                  }
                : deliveryData.misc.deliveryMobile,
              deliveryLocation: values.deliveryLocation,
              withAddress: "true"
            }
            props.setDeliveryData({
              ...deliveryData,
              shippingFee: Number(handlingFee) + Number(data.totalFee),
              courier: courier,
              misc: lalamoveData
            })
          }

          // setFetching(true)
          API_PUBLIC.defaults.headers.common["account-uuid"] =
            props.customerData.account
          await API_PUBLIC.post(
            "checkout/courier/lalamove/get_rate",
            props.deliveryData.courier
          )
        }

        if (is_valid_mobile) {
          if (values.toMe) {
            props.setCustomerData({
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
              mobile: values.mobile
            })
            props.setCustomerAddress({
              addressOne: values.addressOne || "",
              addressTwo: values.addressTwo || "",
              barangay: values.barangay || "",
              city: values.city || "",
              country: values.country || {},
              state: values.state || {},
              zipcode: values.zipcode || ""
            })
            props.setDeliveryData({
              ...props.deliveryData,
              method: values.method || "",
              preferPickup: values.preferPickup,
              pickUpAddress: values.pickUpAddress,
              toMe: values.toMe
              // lalamove: values.lalamove
            })
          } else {
            props.setDeliveryData({
              ...props.deliveryData,
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
              mobile: values.mobile,
              addressOne: values.addressOne || "",
              addressTwo: values.addressTwo || "",
              barangay: values.barangay || "",
              city: values.city || {},
              country: values.country || {},
              state: values.state || {},
              zipcode: values.zipcode || "",
              method: values.method || "",
              preferPickup: values.preferPickup,
              pickUpAddress: values.pickUpAddress,
              toMe: values.toMe,
              // lalamove: values.lalamove,
              deliveryDate: values.deliveryDate || "",
              deliveryTime: values.deliveryTime || ""
            })
          }
          if (values.method.value && values.method.value.name === "Lalamove") {
            props.setDeliveryData({
              ...props.deliveryData,
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
              mobile: values.mobile,
              addressOne: values.addressOne || "",
              addressTwo: values.addressTwo || "",
              barangay: values.barangay.value || "",
              city: values.city.value || values.city || "",
              country: values.country || {},
              state: values.state || {},
              zipcode: values.zipcode || "",
              method: values.method || "",
              courier_id: (values.method && values.method.value.id) || null,
              preferPickup: values.preferPickup,
              pickUpAddress: values.pickUpAddress,
              toMe: values.toMe,
              // lalamove: values.lalamove,
              deliveryDate: values.deliveryDate,
              deliveryTime: values.deliveryTime,
              addressString: values.addressString,
              latLng: values.latLng
            })
          }
          props.setActiveStep("payment")
        } else {
          setFieldError("mobile", "Mobile number is invalid.")
        }
      } catch (error) {
        console.log(error)
        if (
          error.response &&
          error.response.data &&
          error.response.data.data &&
          error.response.data.data.message === "ERR_INVALID_SCHEDULE_TIME"
        ) {
          setFieldError("deliveryTime", "Delivery time is invalid.")
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.data &&
          error.response.data.data.message === "ERR_OUT_OF_SERVICE_AREA"
        ) {
          setFieldError("deliveryLocation", "Delivery location is invalid.")
        }
      }
    } else {
      props.setDeliveryData({
        ...props.deliveryData,
        method: values.method || "",
        preferPickup: values.preferPickup,
        pickUpAddress: values.pickUpAddress,
        toMe: values.toMe
        // lalamove: values.lalamove
      })
      props.setActiveStep("payment")
    }
  }
})(BaseShippingForm)

class ShippingForm extends React.Component {
  render() {
    return <FormikShippingForm {...this.props} />
  }
}

export default ShippingForm
